import React from 'react';

import scss from './HeaderLabel.module.scss';

function HeaderLabel({ children }) {
  return <h2 className={scss.label}>{children}</h2>;
}

export default HeaderLabel;
